import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter, map, startWith } from 'rxjs';

import { AuthStore } from '@core/auth';
import { I18nPipe } from '@core/i18n';
import { NavStore } from '@core/nav';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TabbarComponent } from './components/tabbar/tabbar.component';
import { TopbarComponent } from './components/topbar/topbar.component';

@Component({
  selector: 'ks-shell',
  imports: [I18nPipe, TopbarComponent, SidebarComponent, TabbarComponent, RouterOutlet],
  templateUrl: './shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authStore = inject(AuthStore);
  private readonly navStore = inject(NavStore);

  readonly user = this.authStore.user;
  readonly activeTabId = this.navStore.activeTabId;

  protected readonly padded = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.isPadded(this.route)),
      startWith(this.isPadded(this.route)),
    ),
  );

  toggleMenu(): void {
    const preferences = this.user()?.preferences;

    if (!preferences) return;

    this.authStore.setPreferences({ ...preferences, menuExpanded: !preferences.menuExpanded });
  }

  private isPadded(route: ActivatedRoute): boolean {
    let current: ActivatedRoute | null = route.firstChild;

    while (current?.snapshot) {
      const config = current.routeConfig;

      if (config?.component || config?.loadComponent) {
        return current.snapshot.data['padded'] !== false;
      }

      current = current.firstChild;
    }

    return true;
  }
}
